import i18n from '@/utils/i18n';
import React from 'react';
import { AccountDetailSalesAlertCard } from '@/experiences/sales-portal/domain/accounts/screens/account-detail/components/account-detail-sales-alert-card';
import { AnalyticsAlertType } from '@/types';
import { createStyles } from '@/contexts/theme-context';
import { SalesAlert } from '@/experiences/sales-portal/domain/accounts/screens/account-detail/blocs/types';
import { Typography } from '@usepepper/sprout-kit-ui';
import { useIsMobileBottomNavLayout } from '@sales-portal/blocs/hooks/use-is-mobile-bottom-nav-layout';
import { View } from 'react-native';

const getAlertKey = (alert: SalesAlert): string => {
  if (alert.alertType === AnalyticsAlertType.OverduePayment) {
    return alert.chatUUID;
  }

  return alert.alertUUID;
};

interface AccountDetailSalesAlertsProps {
  salesAlerts: SalesAlert[];
}

export const AccountDetailSalesAlerts: React.FC<
  AccountDetailSalesAlertsProps
> = ({ salesAlerts }) => {
  const [styles] = useStyles();
  const isMobileBottomNavLayout = useIsMobileBottomNavLayout();

  if (salesAlerts.length === 0) {
    return null;
  }

  return (
    <View>
      <View
        style={[
          styles.sectionHeader,
          !isMobileBottomNavLayout ? null : styles.sectionHeaderMobile,
        ]}
      >
        <Typography
          accessibilityRole="header"
          bold={!isMobileBottomNavLayout}
          size={isMobileBottomNavLayout ? '$lg' : '$md'}
          variant="heading"
        >
          {i18n.t('sales_portal.account_detail.sales_alerts.title')}
        </Typography>
      </View>
      <View style={styles.alerts}>
        {salesAlerts.map((alert, index) => (
          <AccountDetailSalesAlertCard
            alert={alert}
            isLast={index === salesAlerts.length - 1}
            key={getAlertKey(alert)}
          />
        ))}
      </View>
    </View>
  );
};

const useStyles = createStyles((theme) => ({
  alerts: {
    gap: theme.sk.spacing.spaceMedium,
  },
  sectionHeader: {
    marginBottom: theme.sk.spacing.spaceSmall,
    paddingBottom: theme.sk.spacing.spaceXsmall,
    paddingTop: theme.sk.spacing.spaceSMedium,
  },
  sectionHeaderMobile: {
    marginBottom: theme.sk.spacing.spaceSMedium,
    paddingTop: 0,
  },
}));
